module.exports = __webpack_public_path__ + "img/cdq2b40-01.prt.1c339c72.jpg";